import { UddannelseTypeEnum } from "core/sharedmodels/stilling/uddannelseTypeEnum";
import StringBuilder from "../stringBuilder";
export const appendGenerelForloebKladdeOverviewPillData = (
    regionNavn: string,
    specialeNavn: string,
    stedInfo: string,
    stillingNummer: string,
    uddannelseType: UddannelseTypeEnum,
    startDato: Date,
    slutDato: Date,
    builder?: StringBuilder
) => {

    const sb = builder ?? new StringBuilder("", '<br/>');
    sb.append(regionNavn);
    sb.append(specialeNavn);
    sb.append(stedInfo);
    sb.append(stillingNummer);
    sb.append(UddannelseTypeEnum[uddannelseType]);
    sb.append(`${startDato.dateWithoutTimeFormat(true)} - ${slutDato.dateWithoutTimeFormat(true)}`);
    return sb;
}
